/*
 *  Author: DL
 *  Date: 2020-12-03 09:53:55
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 18:26:06
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useRef, useLayoutEffect, useEffect, useCallback, useState } from 'react';
import { connect } from 'dva';
import vConsole from 'vconsole';
import location from 'utils/locatoin';
import updateOrientation from 'utils/orientation';
import Fmap from '@/components/Fmap';
import { Confirm } from 'ui';
import mapConfig from 'config/map';
import settingConfig from 'config/setting';
import { isEmpty } from 'utils/tools';
import 'utils/tts';
import styles from './index.less';

const { mapId, showCompass, mapOptions } = mapConfig;
const { isDebug, isLog } = settingConfig;

if (!isLog) {
    window.console.log = function () { };
}

function BasicLayout(props) {
    const [visible, setVisible] = useState(false);
    const globalRef = useRef({ isPage: true });
    const fmap = useRef(null);
    const { map, dispatch } = props;
    const { listGroups, focusGroupId, visibleGroupIDs } = map;

    const handleChangeFloor = useCallback(({ gid }) => dispatch({ type: 'map/updateFocusGroupId', payload: { focusGroupId: gid } }), [dispatch]);

    const handleChangeVisibleGroup = useCallback(({ gids }) => dispatch({ type: 'map/updatevisibleGroupIDs', payload: { visibleGroupIDs: [...gids] } }), [dispatch]);

    const handleOkClick = useCallback(() => {
        updateOrientation(angle => {
            if (fmap.current && fmap.current.locationMarker) {
                fmap.current.locationMarker.direction = angle;
            }

            if (fmap.current && fmap.current.naviLocationMarker) {
                fmap.current.naviLocationMarker.direction = angle;
            }
        });
    }, []);

    const handleCloseClick = useCallback(() => setVisible(false), []);

    useLayoutEffect(() => {
        if (isDebug) {
            new vConsole();
        }
    }, []);

    useEffect(() => {
        const intervalTimer = setInterval(() => {
            if (fmap && fmap.current && fmap.current.loadCompleteStatus) {
                clearInterval(intervalTimer);

                const map = fmap.current.map;

                // 获取地图楼层信息
                const list = map.listGroups.map(({ gid, gname }) => ({ gid, gname }));

                // 初始化楼层信息
                dispatch({ type: 'map/updateListGroups', payload: { listGroups: list.reverse() } });

                if (showCompass) {
                    map.showCompass = true;
                }

                // 实时定位信息
                location(current => {
                    if (isEmpty(current)) return;
                    if (!fmap.current) return;

                    dispatch({ type: 'map/updateCurrent', payload: { current: { ...current } } });

                    const { x, y, groupID } = current;

                    if (globalRef.current.isPage) {
                        if (fmap.current.map.focusGroupId !== groupID) {
                            fmap.current.changeFloor(groupID);
                            fmap.current.map.moveTo({
                                x,
                                y,
                                groupID,
                                callback: () => {
                                    fmap.map.scaleLevelTo({
                                        duration: 1,
                                        level: 23,
                                    });
                                },
                            });

                            globalRef.current.isPage = false;
                        }
                    }

                    fmap.current.updateLocationMarker({ groupID, x, y });
                });

                // 楼层切换事件
                map.on('focusGroupIDChanged', handleChangeFloor);
                map.on('visibleGroupIDsChanged', handleChangeVisibleGroup);

                return () => {
                    map.off('focusGroupIDChanged', handleChangeFloor);
                    map.off('visibleGroupIDsChanged', handleChangeVisibleGroup);
                };
            }
        }, 500);
    }, [dispatch, handleChangeFloor, handleChangeVisibleGroup]);

    useEffect(() => {
        const timer = setInterval(() => {
            if (fmap && fmap.current && fmap.current.loadCompleteStatus) {
                clearInterval(timer);

                if (window.device.os === 'ios') {
                    setVisible(true);
                } else {
                    updateOrientation(angle => {
                        if (fmap.current) {
                            if (fmap.current.locationMarker) {
                                fmap.current.locationMarker.direction = angle;
                            }
                            if (fmap.current.naviLocationMarker) {
                                fmap.current.naviLocationMarker.direction = angle;
                            }
                        }
                    });
                }
            }
        }, 500);
    }, []);

    return (
        <div className={styles.normal}>
            {/* 地图组件 */}
            <Fmap ref={fmap} mapOptions={mapOptions} mapId={mapId} />
            <Confirm visible={visible} message="想要访问动作与方向" onClose={handleCloseClick} onOK={handleOkClick} />
            {/* 子组件 */}
            {React.Children.map(props.children, child =>
                React.cloneElement(child, {
                    children: React.Children.map(child.props.children, child =>
                        React.cloneElement(child, {
                            fmap: fmap.current,
                            listGroups,
                            focusGroupId,
                            visibleModel: visibleGroupIDs.length > 1 ? 'multi' : 'single',
                        }),
                    ),
                }),
            )}
        </div>
    );
}

export default connect(({ map }) => ({ map }))(BasicLayout);
